import { Component, Input, OnInit } from '@angular/core';
import { LeadCounts } from 'src/app/core/interfaces/status-counts/lead-counts';
import { RoleService } from 'src/app/core/services/role/role.service';

@Component({
  selector: 'app-lead-counts',
  templateUrl: './lead-counts.component.html',
  styleUrls: ['./lead-counts.component.scss'],
})
export class LeadCountsComponent implements OnInit {
  @Input() leadCounts: LeadCounts;

  constructor(public role: RoleService) {}

  ngOnInit(): void {}

  getUserRole() {
    return this.role.getCurrentUserRole();
  }
}
